import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../Header/header';
import Footer from '../Footer/footer';
import MessageTemplate from './messageTemplate';

const DownLoadLinkMessage = () => {
  let params = useParams();
  return (
    <>
      <Header />
      <MessageTemplate>
        <p class='text-sm font-medium text-green-800'>
          {params.name === "orit" ? `${process.env.REACT_APP_ORIT_BEN}'s ` : `${process.env.REACT_APP_TAMAR_HARARY}'s `} 
          contact details from Smart Investment will import into your cell phone with your request. Feel free to get in touch
          anytime thereafter. Have a great day!
        </p>
      </MessageTemplate>
      <Footer />
    </>
  );
};

export default DownLoadLinkMessage;
